import styled from 'styled-components';
import { Button } from "@material-ui/core";
import { EventOutlined as EventOutlinedIcon } from "@material-ui/icons";

import tokenWhite from 'images/tokenWhite.svg'

export const Container = styled.div`
  padding: 1rem 1.5rem;
  padding-bottom: 120px;
  background-color: #fff;
  height: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  max-width: 900px;
  margin: 0 auto;
  
  @media(min-width: 768px) {
    padding: 2rem;
    padding-bottom: 140px;
  }
  
  @media (max-height: 700px) {
    padding-bottom: 100px;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
  padding: 0 0.5rem;
`

export const Title = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  
  @media(min-width: 768px) {
    font-size: 1.75rem;
  }
`

export const TokensButton = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  margin-left: 1rem;
  max-height: 1.5rem;
  background-color: #0B4598;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 0.5rem;
`

export const TokenIcon = styled.img.attrs({
    src: tokenWhite,
})`
  width: 16px;
  height: 12px;
  margin-right: 0.25rem;
`

export const StyledButton = styled(Button)`
  position: fixed !important;
  bottom: 1.5rem;
  width: 180px !important;
  left: 0;
  right: 0;
  margin: 0 auto !important;
  padding: 0.75rem 0 !important;
  border-radius: 2rem !important;
`

export const EventOutlinedIconStyled = styled(EventOutlinedIcon)`
  margin-left: 0.25rem;
`

export const NoJobsMessage = styled.div`
  width: 100%;
  text-align: center;
  margin: 3rem 0;
  padding: 0 1.5rem;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.67);
`
